<div *ngIf="isLoaded" class="col-lg-12 d-flex casos-esg-blq-inner-int">

    <div class="col-lg-5 col-md-5 col-sm-0">
        <img [src]="twoColAreaPhotoButton_params.photo" class="img-fluid" alt="foto inicio casos de exito">
    </div>

    <div class="col-lg-7 col-md-7 col-sm-12 col-12 px-lg-5 px-md-5 border-dark border-end border-1 border-lg-0">
        <p class="text-uppercase">{{twoColAreaPhotoButton_params.preTitle}}</p>
        <h1>{{twoColAreaPhotoButton_params.title}}</h1>
        <p>{{twoColAreaPhotoButton_params.mainText}}</p>
        <a class="btn btn-rco" routerLink="{{twoColAreaPhotoButton_params.mainButtonLink}}"><p>{{twoColAreaPhotoButton_params.mainButtonText}}</p></a>
    </div>

</div>
